const defaultFormat = (value: string | number): string | number => parseFloat(value.toString()).toFixed(2);
const formatText = (value: string | number): string | number => value;

interface IPalette {
  background: string;
}

export interface IReportTreeNode {
  title: string;
  field?: string;
  unit: string;
  toFormat: (value: number | string) => number | string;
  palette?: IPalette;
  align?: "left" | "center" | "right";
  children?: IReportTreeNode[];
}

export const Reference: IReportTreeNode = {
  title: "Root",
  unit: "",
  toFormat: defaultFormat,
  children: [{
    title: "Reference",
    field: "reference",
    align: "center",
    unit: "",
    toFormat: formatText
  }]
};

export const TreeStructure: IReportTreeNode = {
  title: "Root",
  unit: "",
  toFormat: defaultFormat,
  children: [{
    title: "Production",
    unit: "",
    palette: { background: "#f3af83" },
    toFormat: defaultFormat,
    children: [{
      title: "Power ON",
      unit: "min",
      palette: { background: "#a8cf8d" },
      toFormat: defaultFormat,
      children: [
        {
          title: "EAF Transformer Power",
          unit: "",
          toFormat: defaultFormat
        }
      ]
    }, {
      title: "Power OFF",
      unit: "min",
      palette: { background: "#fde598" },
      toFormat: defaultFormat,
      children: [{
        title: "Total Delays",
        unit: "min",
        toFormat: defaultFormat
      },
      {
        title: "EAF Operational Delays",
        field: "eaf-operational",
        unit: "min",
        toFormat: defaultFormat
      },
      {
        title: "Caster Operational Delays",
        field: "caster-operational",
        unit: "min",
        toFormat: defaultFormat
      },
      {
        title: "Mechanical Delays",
        field: "eaf-mechanical",
        unit: "min",
        toFormat: defaultFormat
      },
      {
        title: "Electrical Delays",
        field: "eaf-electrical",
        unit: "min",
        toFormat: defaultFormat
      },
      {
        title: "Refractory Delays",
        field: "eaf refractory-operational",
        unit: "min",
        toFormat: defaultFormat
      }]
    }, {
      title: "Tap to Tap",
      unit: "min",
      toFormat: defaultFormat
    }, {
      title: "Productivity",
      unit: "",
      toFormat: defaultFormat
    }, {
      title: "Tons per Heat",
      unit: "",
      toFormat: defaultFormat
    }, {
      title: "Tons charged scrap",
      unit: "",
      toFormat: defaultFormat
    }, {
      title: "Yield",
      unit: "%",
      toFormat: defaultFormat,
      children: [{
        title: "Metallic Losses",
        unit: "%",
        toFormat: defaultFormat,
        children: [{
          title: "Ladles",
          unit: "%",
          toFormat: defaultFormat,
          children: [{
            title: "POG due to failures",
            unit: "%",
            toFormat: defaultFormat
          }, {
            title: "Pit",
            unit: "%",
            toFormat: defaultFormat,
          }
          ]
        }, {
          title: "B Scrap",
          unit: "%",
          toFormat: defaultFormat
        }, {
          title: "Tundish",
          unit: "%",
          toFormat: defaultFormat
        }, {
          title: "EAF pit",
          unit: "%",
          toFormat: defaultFormat
        }, {
          title: "EAF Drains",
          unit: "%",
          toFormat: defaultFormat
        }
        ]
      }, {
        title: "Metallic Losses",
        unit: "Tons",
        toFormat: defaultFormat,
        children: [{
          title: "Ladles",
          unit: "Tons",
          toFormat: defaultFormat,
          children: [{
            title: "POG due to failures",
            unit: "Tons",
            toFormat: defaultFormat
          }, {
            title: "Pit",
            unit: "Tons",
            toFormat: defaultFormat,
          }
          ]
        }, {
          title: "B Scrap",
          unit: "Tons",
          toFormat: defaultFormat
        }, {
          title: "Tundish",
          unit: "Tons",
          toFormat: defaultFormat
        }, {
          title: "EAF pit",
          unit: "Tons",
          toFormat: defaultFormat
        }, {
          title: "EAF Drains",
          unit: "Tons",
          toFormat: defaultFormat
        }
        ]
      }, {
        title: "Slag FeO",
        unit: "%",
        toFormat: defaultFormat
      },
      {
        title: "Slag FeO",
        unit: "Tons",
        toFormat: defaultFormat
      },
      {
        title: "Inventory Adjust",
        unit: "%",
        toFormat: defaultFormat
      },
      {
        title: "Inventory Adjust",
        unit: "Tons",
        toFormat: defaultFormat
      }]
    }, {
      title: "Total Heats Tapped",
      unit: "",
      toFormat: defaultFormat,
      children: [{
        title: "Missed Heats",
        unit: "",
        toFormat: defaultFormat,
        children: [{
          title: "Decision 1",
          unit: "",
          toFormat: defaultFormat
        },
        {
          title: "Decision 2",
          unit: "",
          toFormat: defaultFormat
        }]
      }, {
        title: "Forcepassed Heats",
        unit: "",
        toFormat: defaultFormat,
        children: [{
          title: "Assigned to customer order",
          unit: "",
          toFormat: defaultFormat
        },
        {
          title: "No customer order",
          unit: "",
          toFormat: defaultFormat
        }]
      }, {
        title: "Transition Billets",
        unit: "",
        toFormat: defaultFormat
      }]
    }]
  }]
};
